export const Career_data = {
    title: "Automation Engineer",
    summary:
      "I'm a young enthusiast who is keen on learning new languages/tools/ways to get things done. During the past few years, I've gained experience due to the strong desire of becoming an expert. Today I am an Automation Engineer at one of the leading MNC.",
    describeYourSelfInFewPoints: [
      "Automation Tester(Web/Windows/Api/DB)",
      "TDD/BDD based script development",
      "Agile Tester",
    ],
    startDate: "23-Jul-18",
    experiences: [
      {
        company: "J.P. Morgan Chase",
        startdate: "01-Nov-21",
        enddate: "Present",
        positions: [
          {
            title: "Associate Software Engineer - 601",
            startDate: "Feb-23",
            endDate: "Present",
            responsibilities: [
              "Maintain and Enhance test automation framework.",
              "Implementation & Maintenance of Jules job.",
              "Selenium Grid maintenance on Kubernetes cluster.",
              "Track and Maintenance Automation Kanban board.",
              "Help and Guide team members on test automation.",
            ],
          },
          {
            title: "Software Engineer - 502",
            startDate: "Nov-21",
            endDate: "Jan-23",
            responsibilities: [
              "Framework Creation & Maintenance (Hybrid).",
              "E2E regression script creation, maintenance and execution.",
              "Implemented Selenium Grid with docker. (deployed on Kubernetes cluster)",
              "Leveraging Karate DSL for API testing.",
              "CICT using Jenkins (jenkinsFile).",
              "BVT post deployments.",
              "Automation of sending/receiving files to/from FTP server in Java using FTPClient/Jsch library.",
            ],
          },
        ],
      },
      {
        company: "Infosys LTD",
        startdate: "23-Jul-18",
        enddate: "31-Oct-21",
        positions: [
          {
            title: "Test Engineer",
            startDate: "Apr-21",
            endDate: "Oct-21",
            responsibilities: [
              "E2E regression script creation, maintenance and execution.",
              "Sanity scripts execution and maintenance.",
              "Automation of insprint stories in BDD manner with cucumber.",
              "Guiding scrum team members for story automation.",
            ],
          },
          {
            title: "Senior Testing Executive",
            startDate: "Oct-20",
            endDate: "Mar-21",
            responsibilities: [
              "Enhancement and Maintenance of scripts and testing framework.",
            ],
          },
          {
            title: "Testing Executive",
            startDate: "July-18",
            endDate: "Sept-20",
            responsibilities: [
              "Test script developer for UI testing with the help of selenium and UFT developer in Java",
            ],
          },
        ],
      },
    ],
};
